import { deveLogin } from '../http/api';
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'ProxyHome',
  created() {
    let codeUrl = window.location.href;
    let accToken = this.getCode(codeUrl) || '';
    this.setLoginData(accToken);
  },
  setup() {
    const getCode = url => {
      if (url.indexOf('code') !== -1) {
        let params = url.split('?')[1].split('=')[1];
        return params;
      }
    };
    const setLoginData = async code => {
      const res = await deveLogin({
        code: code
      });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data));
      if (res.code == 200 && res.data) {
        window.parent.postMessage({
          type: 'sendCode',
          data: {
            code,
            confirmed: res.data.confirmed,
            identityType: res.data.identityType
          }
        }, '*');
      }
    };
    return {
      getCode,
      setLoginData
    };
  }
});